import { Panel as PanelCore } from '@studiometa/ui';

/**
 * Panel Class.
 */
export default class Panel extends PanelCore {
  static config = {
    name: 'Panel',
  };

  async open() {
    document.body.classList.add('panel-opened');
    super.open();
  }

  async close() {
    document.body.classList.remove('panel-opened');
    super.close();
  }
}
